let storeDispatch: React.Dispatch<any> | null = null

export const setDispatch = (dispatch: React.Dispatch<any>) => {
  storeDispatch = dispatch
}

export const getDispatch = () => {
  if (!storeDispatch) {
    throw new Error('Dispatch has not been set yet.')
  }
  return storeDispatch
}
